import { useEffect } from 'react';

/**
 * Component that redirects to static HTML files
 * @param {string} htmlPath - The path to the HTML file (e.g., "/our-privacy-policy.html")
 */
const RedirectToHtml = ({ htmlPath }) => {
  useEffect(() => {
    // Redirect to the static HTML file
    window.location.href = htmlPath;
  }, [htmlPath]);

  // Show a loading state while redirecting
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      <span className="ml-3">Redirecting...</span>
    </div>
  );
};

export default RedirectToHtml;
